module.exports = __webpack_public_path__ + "img/scriptolog.4057a5bd.png";